export default __webpack_public_path__ + "static/media/Rectangle 22.0a9a8ee6.png";